import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { VideoStatus } from '../../../../models';

type VideoTypeOption = {
  label: string;
  value: VideoStatus;
};

const videoTypeFilterOptions: VideoTypeOption[] = [
  { label: 'Published', value: 'published' },
  { label: 'Archived', value: 'archived' },
  { label: 'Draft', value: 'draft' },
];

export const useVideoTypeFilterOptions = () => {
  const { t } = useTranslation();

  return useMemo(() => videoTypeFilterOptions.map((option) => ({ ...option, label: t(option.label) })), [t]);
};
